export default { sha: '0fa98a40d2eabaac28c81ba34005e909e1c7a86d', buildNumber: 'undefined' }
